module.exports = __webpack_public_path__ + "7ec20ee6a22990eae8a987de1873bca1.png";